export default __webpack_public_path__ + "static/media/chooseImage.9f4fea09.jpg";